export default theme => ({
  link: {
    color: theme.palette.primary.main,
    display: "inline-block",
    textDecoration: "none",
    whiteSpace: "pre-wrap",
    cursor: "pointer",
  },
});
